import { render, staticRenderFns } from "./signFilePreview.vue?vue&type=template&id=2b859fc3&scoped=true"
import script from "./signFilePreview.vue?vue&type=script&lang=js"
export * from "./signFilePreview.vue?vue&type=script&lang=js"
import style0 from "./signFilePreview.vue?vue&type=style&index=0&id=2b859fc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b859fc3",
  null
  
)

export default component.exports